import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './App';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { BrowserRouter } from 'react-router-dom';

initializeIcons();
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;

// Fix tabindex for dynamically created Tabster dummy elements
const fixTabsterDummyElements = () => {
  document.querySelectorAll('[data-tabster-dummy]:not([tabindex="-1"])').forEach(el => {
    el.setAttribute('tabindex', '-1');
  });
};

// Run initially and observe for new elements
fixTabsterDummyElements();
new MutationObserver(() => fixTabsterDummyElements()).observe(document.body, {
  childList: true,
  subtree: true
});

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>
  ,
  document.getElementById('root'));
